export const GAUSSIAN_EXP_FACTOR = -4 * Math.LN2;
export const ROOT_PI_OVER_LN2 = Math.sqrt(Math.PI / Math.LN2);
export const ROOT_THREE = Math.sqrt(3);
export const ROOT_2LN2 = Math.sqrt(2 * Math.LN2);
export const ROOT_2LN2_MINUS_ONE = Math.sqrt(2 * Math.LN2) - 1;
//# sourceMappingURL=constants.js.map